/** Vocabulary second lines in the rendered language; call them at render time. */
import type { VocabularyWord } from "@/api/voice-vocabulary";
import { translate } from "@/i18n";
import { settingsVoiceVocabularyMessages } from "@/i18n/messages/settings-voice-vocabulary";

const SHOWN = 3;

/** The Vocabulary row's second line: up to three words, then a count. */
export function vocabularySummary(
  words: ReadonlyArray<Pick<VocabularyWord, "text">>,
): string {
  if (words.length === 0)
    return translate(settingsVoiceVocabularyMessages, "vocabularyEmpty");
  const names = words
    .slice(0, SHOWN)
    .map((word) => word.text)
    .join(", ");
  return words.length > SHOWN
    ? translate(settingsVoiceVocabularyMessages, "vocabularyMore", {
        names,
        count: words.length - SHOWN,
      })
    : names;
}

/** A word row's second line: how it was misheard. */
export function heardAsSummary(word: Pick<VocabularyWord, "heard_as">): string {
  return word.heard_as.length > 0
    ? translate(settingsVoiceVocabularyMessages, "heardAsSummary", {
        words: word.heard_as.map((heard) => heard.text).join(", "),
      })
    : translate(settingsVoiceVocabularyMessages, "notMisheard");
}
